module.exports = __webpack_public_path__ + "img/Journalisma1.82c3eef1.png";